<template>
  <div class="jdTablePopModel">
  
    <div class="model-detail">
      <div class="box-detail">
        <span class="box-title">仪器名称：</span>
        <span class="box-content">{{dataModel.instrumentName}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">型号：</span>
        <span class="box-content">{{dataModel.pattern}}</span>
      </div>
      <div class="box-detail">
        <span class="box-title">仪器编号：</span>
        <span class="box-content">{{dataModel.serialNumber}}</span>
      </div>
    </div>
    <div>
      <span class="box-title" style="margin-left: 10px;">本次检定校准日期范围：</span>
      <el-date-picker format="yyyy-MM-dd" size="mini" value-format="yyyy-MM-dd" v-model="date" type="daterange" range-separator="至"
                       start-placeholder="开始日期" end-placeholder="结束日期">
       </el-date-picker>
       <el-button type="primary" size="mini"  @click="inquire">搜索</el-button>
       <el-button size="mini" type="primary" @click="createJd">新增</el-button>
    </div>
    <div class="sysTable">
      <el-table
        :data="record"
        height="500"
        v-loading="loading"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="calibrationMechanism"
          label="检定/校准单位"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="currentAccuracy"
          label="本次检定准确度"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="calibrationTime"
          label="本次检定/校准日期"
          align="calibrationTime"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="certificate"
          label="证书编号"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="nextCalibrationTime"
          label="下次检定/校准有效期"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="measuringRange"
          label="测量范围"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="requirements"
          label="检定要求"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="certFile"
          label="检定/校准结果"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span @click="downResult(scope.row)">
              <i style="color: #00a8ff;font-size: 24px;" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="photoLink"
          label="证书截图"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span @click="showResult(scope.row)">
              <i style="color: #00a8ff;font-size: 24px;" class="el-icon-picture"></i>
            </span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="resultStr"
          label="结果确认"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="states"
          label="状态"
          align="center"
          min-width="80">
          <template slot-scope="scope">
            <span>{{ getStates(scope.row.states) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button @click="updateJd(scope.row)" type="text" size="small" ref="childEdit">编辑</el-button>
            <el-popover
              placement="top"
              width="160"
              :ref="scope.$index">
              <p>确认删除该记录？</p>
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="scope._self.$refs[scope.$index].doClose()">取消</el-button>
                <el-button type="primary" size="mini" @click="scope._self.$refs[scope.$index].doClose();;deleteJd(scope.row)">确定</el-button>
              </div>
              <el-button slot="reference" type="text" size="small">删除</el-button>
            </el-popover>
            <el-button @click="exportJd(scope.row)" type="text" size="small">导出</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog append-to-body title="检定处置" :visible.sync="visible" destroy-on-close
     width="900px" :close-on-click-modal="false">
      <jdPopModel
        v-if="visible"
        :message="popoData"
        @dispose="jdChange"
      ></jdPopModel>
    </el-dialog>

    <el-dialog append-to-body title="检定/校准结果" :visible.sync="resModel.resVisible"
      destroy-on-close width="900px">
      <div>
        <img style="width: 100%;height: auto" :src="resModel.selectPhotoLink"  alt="#"/>
      </div>
    </el-dialog>
    <div class="resource-block">
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="current"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    </div>
  </div>
</template>

<script>
  import jdPopModel from "./jdPopModel1";
  import { getVerify,getVertifyList,deleteJdItem,
    updateJdItem,exportJdItem } from "@/api/depotApi";

  export default {
    name: "jdTablePopModel",
    props:{
      dataModel:{
        type:Object
      }
    },
    components:{
      jdPopModel
    },
    data(){
      return{
        total:0,
      size:10,
      record:[],
        loading:true,
        visible:false,
        date:[],
        popoData:{
          type:"",
          current:{}
        },
        options: [
          {value: 0, label: "正常"},
          {value: 1, label: "降级"},
          {value: 2, label: "停用"},
          {value: 3, label: "需维修"},
          {value: 4, label: "需检定"},
          {value: 5, label: "需保养"},
          {value: 6, label: "报废"},
        ],
        resModel:{
          resVisible:false,
          selectPhotoLink:""
        }
      }
    },
    created() {
      this.getList();
    },
    methods:{
      inquire(){
      this.current = 1;
      this.getList()
    },
      handleSizeChange(page){
      this.size = page;
      this.getList()
    },
    handleCurrentChange(page){
      this.current = page;
      this.getList();
    },
      getList(){
        let self = this;
        self.loading = true;
        let params ={
          current: self.current,
          size:self.size,
        id:self.dataModel.id
      }
      if (self.date&&self.date.length) {
                params.startDate = self.date[0]
                params.endDate = self.date[1]
            }
        getVertifyList(params).then((res) => {
          self.loading = false;
          if (res.code != 200){
            return;
          }
          self.record = res.data.records;
          self.total = res.data.total;
          self.loading = false;
        });
      },
      createJd(){
        this.popoData.current = this.dataModel;
        this.popoData.type = "create";
        this.visible = true;
      },
      jdChange(operation, data) {
        let self = this;
        if (operation) {
          if(self.popoData.type == "create"){
            getVerify(data).then((res) => {
              if (res.code == "200") {
                this.$message({
                  message: "处理成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
              this.getList();
              this.visible = false;
            });
          }else {
            updateJdItem({
              ...data,
              instrumentId:this.dataModel.id,
              photoLink:null
            }).then((res) => {
              if (res.code == "200") {
                this.$message({
                  message: "处理成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
              this.getList();
              this.visible = false;
            });
          }
        } else {
          this.visible = false;
        }
      },
      getStates(val){
        return this.options.find( item => {
          return item.value == val;
        }).label;
      },
      exportJd(val){
        exportJdItem(
          val.id
        ).then((res) => {
          this.mixin.blobDownload(res.data,'检定记录.docx')
        });
      },
      updateJd(val){
        this.popoData.current = {
          ...this.dataModel,
          ...val
        };
        this.popoData.type = "edit";
        this.visible = true;
      },
      deleteJd(val){
        let self = this;
        deleteJdItem({
          id:val.id
        }).then((res) => {
          if (res.code != 200){
            return;
          }
          self.$message({
            message: "删除成功",
            type: "success",
          });
          self.getList();
        });
      },
      showResult(val){
        let self = this;
        self.resModel.selectPhotoLink = val.photoLink;
        self.resModel.resVisible = true;
      },
      downResult(val){
        if(val.certFile) {
          window.open(val.certFile)
        }
        // this.mixin.dowloadFile(val.certFile);
      }
    }
  }
</script>

<style lang="less" scoped>
  .jdTablePopModel{
    .modelHeader{
      width: 100%;
      .headerTitle{
        text-align: center;
      }
      .headerbut{
        float: right;
        line-height: 50px;
      }
    }
    .model-detail{
      width: 100%;
      display: grid;//网格形式
      grid-template-columns:  33% 33% 33%;//这里表明分为3列
      grid-gap: 10px;//每列的间隔
      .box-detail{
        height: 32px;
        line-height: 32px;
        padding: 6px 12px;
        /*box-shadow: 0 0 15px #0071f1 inset;*/
        padding-top: 0;
        border-radius: 6px;
        margin-right: 10px;
        .box-title{
          width: 35%;
        }
        .box-content{
          width: 65%;
        }
      }
    }
  }
  .resource-block{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/jdTablePopModel.vue